import { AddEditCampaignFormData } from "../data/AddEditCampaignForm.data";
import { EditCampaignFormData } from "../data/EditCampaignForm.data";

export const setEmailCampaignDropDown = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name
                });
            }
            return acc;
        }, []);
    }

    const dropDownList = {
        "recipientsByTaggingSelect": filterDropDownList("Tag"),
        "recipientsByIndustrySelect": filterDropDownList("IndustryCode"),
        "recipientsByGenderSelect": filterDropDownList("Gender"),
        "recipientsByJobTitleSelect": filterDropDownList("JobLevel"),
        "recipientsByNationalitySelect": filterDropDownList("Nationality"),
        "recipientsByRaceSelect": filterDropDownList("Race"),
        "recipientsByResidenceStatusSelect": filterDropDownList("ResidentStatus"),
        "recipientsByStatusSelect": filterDropDownList("Status").filter(obj => obj.value === 8 || obj.value === 16 || obj.value === 17 || obj.value === 18 || obj.value === 19 || obj.value === 20),
        "recipientsByCampaignTypeSelect": filterDropDownList("CampaignType"),
    };

    const formFields = [
        ...AddEditCampaignFormData.formFields,
    ];

    const dropdownLists = dropDownList
    formFields.forEach(field => {
        const dropdownList = dropdownLists[field.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};
